import { FC } from 'react';

import PaypalAdd from 'components/paypal-add';

const PaypalPay: FC = () => <PaypalAdd />;

export default PaypalPay;
